/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Twitter = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M14.0951 10.3166L22.2865 1H20.3461L13.2305 9.08779L7.5516 1H1L9.58953 13.2313L1 23H2.9404L10.4497 14.4572L16.4484 23H23M3.64073 2.43174H6.62173L20.3446 21.6386H17.3629"
                        fill={color}
                    />
                </svg>
        );
    };
